import {
    createContext,
    useContext
} from "react";
import type {
    BreadcrumbItemContextType,
    BreadcrumbContextType
} from "./type";

export const BREADCRUMB_DEFAULT_CONTEXT: BreadcrumbContextType = {
    handleFullWidthChange: () => undefined,
    collapseBehaviour: "auto",
    compactBehaviour: "back",
    itemsBeforeCollapse: 1,
    itemsAfterCollapse: 2,
    separator: "chevron",
    isOverflow: false,
    isCompact: false,
    isMeasure: false,
    size: "medium",
    maxItems: 4
};

export const BREADCRUMB_DEFAULT_ITEM_CONTEXT: BreadcrumbItemContextType = {
    hiddenItems: [],
    isFirst: false,
    isLast: false
};

export const BreadcrumbContext = createContext<BreadcrumbContextType>(BREADCRUMB_DEFAULT_CONTEXT);

export const BreadcrumbItemContext = createContext<BreadcrumbItemContextType>(BREADCRUMB_DEFAULT_ITEM_CONTEXT);

export const useBreadcrumbContext = () => useContext(BreadcrumbContext);

export const useBreadcrumbItemContext = () => useContext(BreadcrumbItemContext);
